/**
 * The Seabreeze Header needs a Parallax Effect.
 * On scroll we need to check for the amount scrolled and:
 *     - update the scrim's opacity
 *     - update the header's position
 */
export default function headerParallax() {
  const header = document.querySelector('.header');
  if (!header) return;

  _updateHeaderParallaxSettings(header);

  window.addEventListener('scroll', () => {
    _updateHeaderParallaxSettings(header)
  })
}

function _updateHeaderParallaxSettings(header) {
  const headerSpeed = 8;
  const newOpacity = window.scrollY / window.innerHeight * 100;

  header.style.top = - (window.scrollY / headerSpeed) + 'px';
  header.style.setProperty('--header-parallax-scrim', newOpacity + '%');
}
